import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";

export default function Page() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null);
    setNotFound(false);
    api
      .get(`/pages/${slug}`)
      .then((r) => setPage(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-24 text-center">
        <h1 className="text-3xl font-display font-bold text-[#1A231C]">Page not found</h1>
        <Link to="/" className="inline-flex items-center gap-1 mt-4 text-[var(--brand-primary)] font-medium">
          <ArrowLeft className="w-4 h-4" /> Back home
        </Link>
      </div>
    );
  }

  if (!page) return <div className="py-24 text-center text-[#5C665D]">Loading...</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#1A231C] font-display" data-testid="page-title">
        {page.title}
      </h1>
      <div className="mt-6 text-[#5C665D] leading-relaxed whitespace-pre-line text-base" data-testid="page-content">
        {page.content}
      </div>
    </div>
  );
}
